import { asyncFlow } from '@helo/utils'

import { UpdateUserSettingsInput } from '../../../gql/graphql'
import { updateUserSettingsMutation } from '../../../queries/graphql/graphqlQueries'
import { apolloClient } from '../../../services/apolloClient'
import { UserSettingsSlice } from './userSettingsSlice'
import { UserSettingsSliceParts } from './userSettingsslice.parts'

const loadUserSettings = () =>
  asyncFlow(
    UserSettingsSliceParts.retrieveUserSettings(),
    UserSettingsSliceParts.setClarityCookieConsent(),
  )

const updateUserSettings = (settings: UpdateUserSettingsInput) =>
  asyncFlow(asyncFlow.inputExtends<UserSettingsSlice>(), async inputStore => {
    const { data } = await apolloClient.mutate({
      mutation: updateUserSettingsMutation,
      variables: {
        input: settings,
      },
    })
    return {
      ...inputStore,
      userSettings: {
        ...inputStore.userSettings,
        settings: data?.updateUserSettings,
      },
    }
  })

export const UserSettingsSliceActions = {
  loadUserSettings,
  updateUserSettings,
}
